import { ChangeDetectionStrategy, Component, Input, OnInit } from "@angular/core";
import { TableAction, TableActionDisplay, TableActionOptions } from "@app/shared/model/action.model";
import { BehaviorSubject } from "rxjs";

@Component({
    selector: "table-custom-action-container",
    templateUrl: "./table-custom-action-container.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableCustomActionContainerComponent implements OnInit {
    @Input() tableActionOptions: TableActionOptions;
    @Input() selectedRow: any;

    public actionList$ = new BehaviorSubject<TableAction[]>(null);

    ngOnInit(): void {
        if (this.tableActionOptions?.selectionListener) {
            this.tableActionOptions.selectionListener(this.selectedRow, this.actionList$);
        }
    }

    get tableActionDisplay() {
        if (!this.tableActionOptions?.display || this.tableActionOptions.display === TableActionDisplay.default) {
            return TableActionDisplay.overflow;
        }
        return this.tableActionOptions.display;
    }

    get isOverflowView() {
        return this.tableActionDisplay === TableActionDisplay.overflow;
    }
}
